module.exports = __webpack_public_path__ + "static/media/power.95b5b6ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/Imgs/power.png
// module id = 69
// module chunks = 0